import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SocialPlatforms from './SocialPlatforms';
import BioLinkActionPlatforms from './BioLinkActionPlatforms';
import usePreviewBackground from './usePreviewBackground';

export default function BioLinkPreview({ previewData }) {
    const {
        linktype,
        background,
        title,
        description,
        image,
        socialPlatforms,
        platforms
    } = previewData;

    let release = {
        image: image
    }
    const bg = usePreviewBackground(background, release);

    return (
        <div className="device-wrapper w-full relative bg-cover bg-center rounded-[36px] border-8 border-[#B2B2B2] overflow-hidden"
            style={{ background: bg.background }}
        >
            {/* Blur Background Layer */}
            {bg.blur && (
                <div
                    className="absolute inset-0 scale-125 blur-3xl"
                    style={{
                        backgroundImage: `url(${image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }}
                />
            )}

            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/70 to-black/50"></div>

            {/* Notch */}
            <div className="absolute top-[10px] left-1/2 transform -translate-x-1/2 bg-black h-6 w-24 border border-light rounded-full z-10"></div>

            {/* Screen Content */}
            <div className="relative pt-12 pb-4 px-8">

                <div className="content-wrapper mb-6">
                    <div className="flex justify-center mb-6">
                        <div
                            className="relative w-[160px] h-[160px] bg-cover bg-center rounded-md shadow-xl"
                            style={{ backgroundImage: `url(${image})` }}
                        >
                        </div>
                    </div>

                    {/* Title and Description */}
                    <div className="text-center mb-6">
                        <h2 className="text-white text-3xl font-bold mb-2">
                            {title || (linktype === 'biolink' ? "Bio Title" : "Tour Title")}
                        </h2>

                        <p className="text-gray-300 text-sm">
                            {description || (linktype === 'biolink'
                                ? "Your Bio Link Description"
                                : "Your Tour Link Description")}
                        </p>
                    </div>

                    {/* Modern Layout */}
                    <div className="list-wrapper max-h-[250px] space-y-2 overflow-auto pr-2
                                    [&::-webkit-scrollbar]:w-[6px]
                                    [&::-webkit-scrollbar-track]:bg-gray-100
                                     [&::-webkit-scrollbar-thumb]:bg-gray-300
                                    [&::-webkit-scrollbar-thumb]:rounded-full
                                    hover:[&::-webkit-scrollbar-thumb]:bg-gray-400
                                    [scrollbar-width:thin]
                                    [scrollbar-color:#d1d5db_#f3f4f6]"
                    >
                        <div className="pr-1">
                            <BioLinkActionPlatforms
                                platforms={platforms}
                            />
                        </div>
                    </div>
                </div>

                {/* Social Media Icons */}
                <div className="social-wrapper text-center mb-4">
                    <div className="text-sm text-white font-semibold mb-2">Follow on:</div>
                    <SocialPlatforms
                        platforms={socialPlatforms}
                        variant="modern"
                    />
                </div>

                {/* Footer Text */}
                <div className="text-center mb-4">
                    <p className="text-gray-300 text-xs leading-relaxed">
                        By using this site you agree to our <Link to={'/terms-of-service'} className="text-white font-bold">Terms of Use</Link> and <Link to={'/privacy-policy'} className="text-white font-bold">Privacy Policy</Link>
                    </p>
                </div>

                {/* Copyright */}
                <div className="text-center">
                    <p className="text-gray-300 text-xs">Copyright © 2026</p>
                </div>
            </div>
        </div>
    );
}